/**
 * Hook for managing contextual help drawer state
 */

import { useState } from "react";
import { getHelpContent } from "@/data/help-content";
import { HelpContent } from "@/types/help-content";

export function useContextualHelp(pageId: string) {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const helpContent = getHelpContent(pageId);

  const openHelp = () => setIsHelpOpen(true);
  const closeHelp = () => setIsHelpOpen(false);
  const toggleHelp = () => setIsHelpOpen((prev) => !prev);

  return {
    isHelpOpen,
    helpContent,
    openHelp,
    closeHelp,
    toggleHelp,
    setIsHelpOpen,
  };
}
